import React, { useState } from 'react';
import './MenuPopupDeliveryAdd.scss';
import './MenuPopupDeliveryAdd-media.scss';
import { AddMenu } from './constants';

import Button from '../../Button/Button';
import { ClosedSubMenuComponent, bodyAuto } from '../../../services/GlobalFunctions';
import { createPortal } from 'react-dom';
import ModalFormFeedback from '../../ModalFormFeedback/ModalFormFeedback';
import { SelectValuesFormSimple } from '../../../services/content/Constants';
import {content} from "../../../services/content";
import {Link} from "../../Link/Link";

const MenuPopupDeliveryAdd = () => {
  const [showModalPartner, setShowModalPartner] = useState(false);

  const openModal = () => {
    setShowModalPartner(true);
    ClosedSubMenuComponent();
  };

  const closedModal = () => {
    bodyAuto();
    setShowModalPartner(false);
    ClosedSubMenuComponent();
  };

  return (
    <div className="menu-popup-delivery-add">
      <div className="menu-popup-delivery-add__links">
        {AddMenu.map(({ text, link }, i) => (
          <Link to={link} className="menu-popup-delivery-add__link" key={i} onClick={ClosedSubMenuComponent}>
            <p dangerouslySetInnerHTML={{ __html: text }}></p>
          </Link>
        ))}
      </div>

      <div className="menu-popup-delivery-add__buttons">
        {/* <Button
          text="Калькулятор"
          link={EnumUrlsPages.calculator}
          onClick={ClosedSubMenuComponent}
          type="border"
          size="S"
          widthAll
        /> */}
      </div>

      {createPortal(
        <ModalFormFeedback
          hasCssTransition
          showForm={showModalPartner}
          id="partner"
          title={content.header.textBecomePartner}
          select={{
            options: [],
            disabled: true,
            active: SelectValuesFormSimple.find((x) => x.eventMetrika === 'form_partner'),
          }}
          closedModal={closedModal}
          eventMetrika="form_partner"
          sendAmoCRM
        />,
        document.body
      )}
    </div>
  );
};

export default MenuPopupDeliveryAdd;
